module.exports = __webpack_public_path__ + "static/call_sheet_page-d17254e113ee680d7e224b284a5afcd8.png";